import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: [],
    fc_40Detalle: [],
    contadorPedido: 0,
}

//types
const SOLICITUDES_COMPRAS_FINANZAS_EXITO = 'SOLICITUDES_COMPRAS_FINANZAS_EXITO'
const SOLICITUDES_COMPRAS_HOLOGRAMAS_EXITO = 'SOLICITUDES_COMPRAS_HOLOGRAMAS_EXITO'
const SOLICITUD_DETALLE_COMPRA_EXITO = 'SOLICITUD_DETALLE_COMPRA_EXITO'
const AGREGAR_COMPRA_EXITO = 'AGREGAR_COMPRA_EXITO'
const ACTUALIZAR_COMPRA_EXITO = 'ACTUALIZAR_COMPRA_EXITO'
const CONTADOR_SOLICITUD_COMPRA_EXITO = 'CONTADOR_SOLICITUD_COMPRA_EXITO'
const ACTUALIZAR_FC_40_EXITO = 'ACTUALIZAR_FC_40_EXITO'
const SOLICITUDES_COMPRAS_AC_EXITO = 'SOLICITUDES_COMPRAS_AC_EXITO'
export const obtenerSolicitudesCompraFinanzas = createAsyncThunk(
    SOLICITUDES_COMPRAS_FINANZAS_EXITO,
    async () => {
        try {
            const fullUrl = host + `ModuloHolograma/ObtenerSolicitudesFC_40ComprasFinanzas`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerSolicitudesCompraHologramas = createAsyncThunk(
    SOLICITUDES_COMPRAS_HOLOGRAMAS_EXITO,
    async () => {
        try {
            const fullUrl = host + `ModuloHolograma/ObtenerSolicitudesFC_40ComprasHologramas`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerCompraDetalle = createAsyncThunk(
    SOLICITUD_DETALLE_COMPRA_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `ModuloHolograma/ObtenerSolicitudFC_40ComprasDetalle/${id}`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarInformacionCompra = createAsyncThunk(
    AGREGAR_COMPRA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `ModuloHolograma/AgregarInformacionCompra`
            const fullUrlFC_40 = host + `FC_40/actualizarFormatoFC40`

            const res = await axios.post(fullUrl, { data: data })

            let dataActualizarFC_40 = { idfc40_solicitudadquisicionholo: data.idfc40_solicitudadquisicionholo, isatendidafinanzas: true }
            await axios.put(fullUrlFC_40, { data: dataActualizarFC_40 })

            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)

export const actualizarInformacionCompraHologramas = createAsyncThunk(
    ACTUALIZAR_COMPRA_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `ModuloHolograma/ActualizarInformacionCompra`
            const fullUrlFC_40 = host + `FC_40/actualizarFormatoFC40`
            const fullUrlnventario = host + `ModuloInventario/AgregarInventario`

            let dataActualizar = {
                idcomprahologramas: data.idcomprahologramas, fechaatendida: data.fecha,
                prefijo: data.prefijo, folioinicial: data.folioinicial, foliofinal: data.foliofinal
            }
            const res = await axios.put(fullUrl, { data: dataActualizar })

            let dataActualizarFC_40 = { idfc40_solicitudadquisicionholo: data.idfc40_solicitudadquisicionholo, isatendidahologramas: true }
            await axios.put(fullUrlFC_40, { data: dataActualizarFC_40 })

            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)


export const obtenerContadorCompras = createAsyncThunk(
    CONTADOR_SOLICITUD_COMPRA_EXITO,
    async () => {
        try {
            const fullUrl = host + `ModuloHolograma/ObtenerContadorSolicitudesCompras`
            const res = await axios.get(fullUrl)
            console.log("res.data.data ", res.data.data)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ObtenerSolicitudesFC_40ConsultaAC = createAsyncThunk(
    SOLICITUDES_COMPRAS_AC_EXITO,
    async () => {
        try {
            const fullUrl = host + `ModuloHolograma/ObtenerSolicitudesFC_40ConsultaAC`
            const res = await axios.get(fullUrl)
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const ModuloComprasSlice = createSlice({
    name: 'ModuloComprasSlice',
    initialState: dataInicial,
    reducers: {},
    extraReducers: {
        [obtenerSolicitudesCompraFinanzas.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [obtenerSolicitudesCompraHologramas.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
        [obtenerCompraDetalle.fulfilled]: (state, { payload }) => {
            state.fc_40Detalle = payload
        },
        [obtenerContadorCompras.fulfilled]: (state, { payload }) => {
            state.contadorPedido = payload
        },
        [ObtenerSolicitudesFC_40ConsultaAC.fulfilled]: (state, { payload }) => {
            state.data = payload
        },
    },
})

export const { } = ModuloComprasSlice.actions

export const ModuloComprasReducer = ModuloComprasSlice.reducer
